module.exports = __webpack_public_path__ + "static/media/oitoempty.1ce92b61.svg";